export default "__VITE_ASSET__03ee1479__"